<template>
  <div class="tab-form">
    <h3 class="row mb-3 mt-3">タブ({{defaultListTab.length}})</h3>
    <v-row>
      <v-text-field
        v-model="keyword"
        hide-details
        dense
        @keyup.enter="search"
        class="text-field-search mr-10"
        outlined
      />
      <v-btn color="primary" class="font-weight-black" @click="search">{{$t('SEARCH')}}</v-btn>
      <v-spacer />
      <v-select
        class="select-record"
        hide-details
        :items="recordsPage"
        v-model="pagination.maxResultCount"
        dense
        outlined
      />
      <TabAdd @resetList="handleResetList" />
    </v-row>
    <v-row>
      <v-layout child-flex class="pad-top-button">
        <v-data-iterator
          :items-per-page.sync="pagination.maxResultCount"
          :page="pagination.page"
          :key="keyListTab"
          :loading="loading"
          :items="listTab"
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-row>
              <v-col v-for="(item,index) in props.items" :key="index" cols="2" class="card-list">
                <v-card
                  color="#f5f5f5"
                  @click="$router.push({name: 'Detail Tab', params: {tabId: item.Id}})"
                >
                  <v-card-text class="align-start py-3">
                    <div
                      class="font-weight-bold text-truncate"
                      style="max-width: 182px;"
                    >{{ item.name.ja }}</div>
                    <div class="row pa-0 ma-0">
                      <div class="icon-trash">
                        <TabUpdate :item="item" @resetList="handleResetList" />
                        <TabDelete :item="item" @resetList="handleResetList" />
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <template v-slot:no-data>
            <div class="text-center mt-5">データがありません。</div>
          </template>
        </v-data-iterator>
        <template v-slot:loading>
            <div class="text-center mt-5">読み込み中。。。待ってください。</div>
          </template>
      </v-layout>
    </v-row>
    <BasePagination
      v-if="listTab.length > 0"
      :pageCount="listTab.length"
      :pageSize="pagination.maxResultCount"
      @changePage="changePage"
    />
  </div>
</template>
<script>
import mixin from "@/mixin";
import BasePagination from "@/components/Pagination/BasePagination";
import TabAdd from "./TabAdd";
import TabUpdate from "./TabUpdate";
import TabDelete from "./TabDelete";
import { getListTab } from "@/api/Tab.api";

export default {
  mixins: [mixin.App],
  components: {
    BasePagination,
    TabAdd,
    TabUpdate,
    TabDelete,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      listTab: [],
      defaultListTab: [],
      keyListTab: 0,
      keyword: "",
    };
  },
  async mounted() {
    await this.handleGetListTab();
  },
  methods: {
    async handleGetListTab() {
      this.keyListTab++;
      let params = {
        keyword: "",
      };
      this.loading = true;
      await getListTab(params)
        .then((data) => {
          this.defaultListTab = data.result;
          this.listTab = data.result;
          this.pagination.pageCount = data.totalCount;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    async search() {
      await this.handleGetListTab();
      const { keyword } = this;
      let keywordSearch = keyword.toLowerCase();
      this.listTab = this.defaultListTab.filter(
        (item) => item.name.ja.toLowerCase().search(keywordSearch) > -1
      );
      this.pagination.pageCount = this.listTab.length;
    },
    async handleResetList() {
      if (this.keyword !== "") return (this.keyword = "");
      await this.handleGetListTab();
    },
    onClickChild(value) {
      console.log(value); // someValue
    },
    changePage(value) {
      this.pagination.page = value;
    },
  },
};
</script>
<style scoped>
.tab-form {
  margin-top: 60px;
}
.mt-1 {
  margin-top: 0 !important;
}
.btn-search-tab {
  margin-left: 15px;
}
.pad-top-button {
  padding-top: 0;
  padding-bottom: 0;
}
.pad-button {
  padding-bottom: 0 !important;
}
.title-style {
  font-size: 18px;
  line-height: 18px;
}
.form-category {
  margin-top: 60px;
}
.v-icon.v-icon {
  margin-right: 5px;
}
</style>